import {cloneDeep} from 'lodash';
import moment from 'moment';

export const validateSum = (list, x) => {
  const sum = list.reduce((acc, item) => {
    const value = typeof item === 'string' ? parseFloat(item.replace(',', '.')) : item;
    if (!isNaN(value)) {
      return acc + value;
    }
    return acc;
  }, 0);

  return Math.abs(sum - x) < Number.EPSILON;
};


const insertRow = (alldata, index, row) => {
  return [...alldata.slice(0, index), {...row, 'isModified': false}, ...alldata.slice(index + 1)];
};

export const updateItem = (ordersProcessedData, payload, key) => {
  const indexObject = ordersProcessedData.findIndex(
    (odr) => odr[key] === payload[key]);
  if (indexObject !== -1) {
    const newOrdersProcessedData = cloneDeep(ordersProcessedData);
    const orderLine = {...newOrdersProcessedData[indexObject], ...payload};
    return insertRow(newOrdersProcessedData, indexObject, orderLine);
  }
  return ordersProcessedData;
};


const getMonthsInRange = (startDate, endDate) => {
  const [startMonth, startYear] = startDate.split('/');
  const [endMonth, endYear] = endDate.split('/');
  const start = moment(`${startYear}-${startMonth}-01`, 'YYYY-MM-DD');
  const end = moment(`${endYear}-${endMonth}-01`, 'YYYY-MM-DD');
  let currentDate = start;
  const months = [];
  while (currentDate <= end) {
    months.push(currentDate.toDate());
    
    currentDate.add(1, 'months');
  }
  
  return months;
};

export const getAllMonthsInRange = (objects) => {
  const allMonths = [];

  objects.forEach((obj) => {
    const months = getMonthsInRange(obj.startDate, obj.endDate);
    allMonths.push(...months);
  });
  return allMonths.sort();
};

export const removeRangeFromDatesList = (startDate, productionsList, datesList) => {
  const {endDate} = productionsList.find(((item) => item.startDate === startDate)) || {};
  const currRange = getMonthsInRange(startDate, endDate);
  const formattedCurrRange = currRange.map((date) => moment(date).format('MM/YYYY'));
  return datesList.filter((date) => !formattedCurrRange.includes(moment(date).format('MM/YYYY')));
};

export const getNextDate = (dateValue, datesList) => {
  const [month, year] = dateValue.split('/');
  let nextDate = moment(`${year}-${month}-01`, 'YYYY-MM-DD').toDate();
  
  for (let i = 0; i < datesList.length; i++) {
    if (moment(datesList[i]).format('YYYY/MM') > moment(nextDate).format('YYYY/MM')) {
      nextDate = datesList[i];
      break;
    }
  }
  if (!(moment(nextDate).format('YYYY-MM') === dateValue)) {
    return nextDate;
  }
  return null;
};
